import $ from 'jquery';

var el = $( '.header' );
//var height = el.outerHeight();
var height = 80;

$( '.js-scroll-to, .js-page-anchors a' ).on('click', function( event ) {
	if (
		location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) &&
		location.hostname === this.hostname
	) {
		var target = $( this.hash );
		target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
		if ( target.length ) {
			$( 'html, body' ).animate( {
				scrollTop: target.offset().top - height
			}, 1000 );
		}
	}
} );
